//export default 'https://app.gosmart.mn/penaltyClientCore'
export default 'http://p.ubtraffic.mn/t'